import { keyBy, isEqual } from 'lodash';

const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
const WEEKEND_DAYS = ['SATURDAY', 'SUNDAY'];

const PRE_ORDER_ALLOWED_CODE = 200;
//const PRE_ORDER_NOT_ALLOWED_CODE = 409;
const PRE_ORDER_COMPLETED_CODE = 410;

export const combineBusinessHours = (groupedBusinessHours) => {
  const start = groupedBusinessHours[0];
  const end = groupedBusinessHours[groupedBusinessHours.length - 1];
  const { hours } = start;
  return {
    day: start === end ? start.day : `${start.day} - ${end.day}`,
    hours: hours ? `${hours.start} - ${hours.end}` : 'CLOSED',
  };
};

export const normalizeBusinessHours = (businessHours) => {
  businessHours = keyBy(businessHours, 'day');
  const getBusinessHours = (day) => {
    return businessHours[day] || { day: day, hours: null };
  };

  const normalizedBusinessHours = [];

  // Group together weekdays (M-F) if contigious days have the same hours.
  let groupedBusinessHours = [getBusinessHours(WEEKDAYS[0])];
  for (let i = 1; i < WEEKDAYS.length; i++) {
    const hours = getBusinessHours(WEEKDAYS[i]);
    if (isEqual(groupedBusinessHours[0].hours, hours.hours)) {
      groupedBusinessHours.push(hours);
    } else {
      normalizedBusinessHours.push(combineBusinessHours(groupedBusinessHours));
      groupedBusinessHours = [hours];
    }
  }
  normalizedBusinessHours.push(combineBusinessHours(groupedBusinessHours));

  // Never group together weekend days.
  for (const day of WEEKEND_DAYS) {
    const hours = getBusinessHours(day);
    normalizedBusinessHours.push(combineBusinessHours([hours]));
  }

  return normalizedBusinessHours;
};

export const getConfigParams = (configUrl) => {
  if (!configUrl) {
    return {};
  }
  const searchParams = new URL(configUrl).searchParams;
  return {
    ss: searchParams.get('ss'),
    styleId: searchParams.get('styleId'),
    postalCode: searchParams.get('postalCode'),
  };
};

const normalizeReservation = (response) => {
  if (
    response.status !== PRE_ORDER_ALLOWED_CODE &&
    response.status !== PRE_ORDER_COMPLETED_CODE
  ) {
    throw new Error(response.reservationStatus);
  }

  const isPreOrderCompleted = response.status === PRE_ORDER_COMPLETED_CODE;

  const dealer = {
    ...response.dealer,
    businessHours: normalizeBusinessHours(response.dealer.businessHours),
  };

  const { ss, styleId, postalCode } = response.config || {
    ss: '',
    styleId: '',
    postalCode: '',
  };

  return {
    ...response,
    dealer,
    isPreOrderCompleted,
    ss,
    styleId,
    postalCode,
    alternateDriveType: '',
  };
};

export default normalizeReservation;
